import styled from "styled-components";
export const ContentModal = styled.div`
  position: absolute;
  width: 850px;
  height: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 4px 4px ${({ theme }) => theme.shadows.strong};
  border-radius: 8px;
  background: ${({ theme }) => theme.primaryBackgroundLight};
  border: 1px solid ${({ theme }) => theme.neutral.gray[700]};
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  .form-instant-message {
    border-top: none;
    border-left: none;
    border-right: none;
    width: 85%;
    margin-left: 0.5em;
    &:focus {
      box-shadow: none;
      border-bottom-color: ${({ theme }) => theme.primary.purple};
    }
  }
`;

export const CloseModal = styled.div`
  height: 3.5em;
  width: 100%;
  text-align: end;
  font-weight: 600;
  cursor: pointer;
`;

export const TextModal = styled.div`
  padding: 0 2em;
  width: 100%;
  .MuiToolbar-regular {
    min-height: 0px;
  }
`;

export const LabelText = styled.p`
  font-style: italic;
  font-weight: 400;
  font-size: 13px;
  color: #636363;
  margin-left: 1em;
`;

export const ButtonClose = styled.button`
  color: white;
  width: 129px;
  height: 33px;
  background: ${({ theme }) => theme.button.primary};
  border-radius: 4px;
  border: none;
  font-size: 14px;
  margin-bottom: 1em;
  &:hover {
    box-shadow: 0px 4px 20px 0px ${({ theme }) => theme.shadows.strong};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;

export const InstantMessage = styled.div`
  font-size: 13px;
  background-color: ${({ itemSelected, theme }) =>
    itemSelected ? theme.background.tertiary : theme.neutral.white};
  border-radius: 20px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 1em;
  margin-left: 0.5em;
  margin-bottom: 0.5em;
  &:hover {
    background-color: ${({ theme }) => theme.background.tertiary};
    cursor: pointer;
  }
`;

export const ButtonSend = styled.button`
  color: white;
  background-color: ${({ itemSelected, theme }) =>
    itemSelected ? theme.button.primary : theme.text.disabled};
  border-radius: 4px;
  width: 69px;
  height: 32px;
  border: none;
  &:hover {
    box-shadow: 0px 4px 20px 0px ${({ theme }) => theme.shadows.strong};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;

export const ContentForm = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const ContentInstantMessages = styled.div`
  overflow-y: auto;
  max-height: 16vw;
  margin-bottom: 1em;
`;
